import 'Vendor/owlcarousel/owl.carousel.min';
import { speed } from 'Lib/speed/speed';
import { onScreen } from 'Lib/on-screen/on-screen';
import { loadSrcOrBg } from 'Lib/load-src-or-bg/load-src-or-bg';

const cSliderOn = 'owl-carousel';

function init() {
    const $photogallerySlider = $('.photogallery-slider');

    $photogallerySlider.trigger('destroy.owl.carousel')
        .removeClass(cSliderOn)
        .addClass(cSliderOn)
        .owlCarousel({
            smartSpeed: speed,
            dots: false,
            margin: 16,
            navClass: ['photogallery-slider__prev arrow arrow_prev', 'photogallery-slider__next arrow arrow_next'],
            navText: ['', ''],
            responsive: {
                0: { items: 2 },
                560: { items: 3 },
                700: { items: 4 },
                992: { items: 5, slideBy: 5, nav: true },
                1150: { items: 6, slideBy: 6, nav: true },
                1300: { items: 8, slideBy: 8, nav: true },
            },
            onInitialized(evt) {
                onScreen($(evt.target).find('.photogallery-slider__item-img'), loadSrcOrBg);
            },
        });

    $('.photogallery-slider__item-box').fancybox({
        loop: true,
        infobar: false,
        toolbar: false,
        btnTpl: {
            close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"></button>',
            arrowLeft: '<a data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}" href="javascript:;"></a>',
            arrowRight: '<a data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}" href="javascript:;"></a>',
            smallBtn: '<button data-fancybox-close class="fancybox-close-small" title="{{CLOSE}}"></button>',
        },
        beforeLoad() {
            $('.fancybox-caption').css('opacity', '0');
        },
    });

    $(document).on('afterShow.fb', (e, instance) => {
        $('.fancybox-content-caption').remove();

        if (instance && instance.length) {
            $('.fancybox-content').append(`
            <div class="fancybox-content-caption" style='
                position: absolute;
                bottom: -25px;
                color: #A6A6A6;
                font-style: italic;
                font-weight: normal;
                font-size: 13px;
                line-height: 20px;
            '>
                ${instance?.$caption[0]?.innerText}
            </div>
        `);
        }
    });

    onScreen($photogallerySlider.find('.photogallery-slider__item-img'), loadSrcOrBg);
}

init();
$('body').on('bitrixDynamicComposite.eksmo', () => init());